
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/register",
      function () {
        return require("private-next-pages/my-account/register.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/register"])
      });
    }
  